import type { JobCostOverviewDto } from '../types/jobCostOverview';
import type { ChargeOverviewLineItemDto, PaymentOverviewLineItemDto } from '../types/jobCostOverview';
import type { JobDetailDto } from '../types';
import { ContractsPanel } from './ContractsPanel';
import { PaymentsPanel } from './PaymentsPanel';
import { CustomerSummaryPanel } from './CustomerSummaryPanel';
import { SubcontractorPanel } from './SubcontractorPanel';
import { SubcontractorAssignment } from './SubcontractorAssignment';
import { PayrollPanel } from './PayrollPanel';
import { EstimatorInfoPanel } from './EstimatorInfoPanel';

interface CostOverviewSidebarProps {
  jobId: number;
  job: JobDetailDto;
  data: JobCostOverviewDto;
  onAddCharge: () => void;
  onEditCharge: (charge: ChargeOverviewLineItemDto) => void;
  onAddPayment: () => void;
  onEditPayment: (payment: PaymentOverviewLineItemDto) => void;
  onJobUpdate: () => void;
}

export function CostOverviewSidebar({
  jobId,
  job,
  data,
  onAddCharge,
  onEditCharge,
  onAddPayment,
  onEditPayment,
  onJobUpdate,
}: CostOverviewSidebarProps) {
  const subCommission = data.commissions?.find((c) => c.commissionType === 'Subcontractor');
  const payrollCommission = data.commissions?.find((c) => c.commissionType === 'Payroll');
  const estimatorCommission = data.commissions?.find((c) => c.commissionType === 'Estimator');

  return (
    <div className="space-y-2">
      <ContractsPanel
        jobId={jobId}
        charges={data.charges}
        chargeTotal={data.chargeTotal}
        onAddCharge={onAddCharge}
        onEditCharge={onEditCharge}
      />

      <PaymentsPanel
        jobId={jobId}
        payments={data.payments}
        paymentTotal={data.paymentTotal}
        onAddPayment={onAddPayment}
        onEditPayment={onEditPayment}
      />

      <CustomerSummaryPanel summary={data.customerSummary} />

      <SubcontractorAssignment
        jobId={jobId}
        currentSubcontractorId={job.subcontractorId}
        currentSubcontractorName={job.subcontractorName}
        onUpdate={onJobUpdate}
      />

      {subCommission && <SubcontractorPanel commission={subCommission} />}
      {payrollCommission && <PayrollPanel commission={payrollCommission} />}
      {estimatorCommission && <EstimatorInfoPanel commission={estimatorCommission} />}
    </div>
  );
}
